<template>
  <div id="sidebar" class="pt-0">
    <div class="cap_leftbar p_right">
      <div class="left_scrollbar">
        <div class="cap_logo border-bottom d-flex align-items-center">
          <div class="logoMian w-100">
            <router-link title="Dashboard" :to="'/dashboard'" class="green">
              <img
                src="../../../../static/fxView/images/stackflow_logo.svg"
                alt="Logo"
            /></router-link>
          </div>
        </div>
        <div
          class="scrollbar"
          :class="
            permissionModule('CREATE_CATEGORY', 'view') ||
            permissionModule('CATEGORY_LIST', 'view') ||
            permissionModule('CREATE_ARTICLE', 'view') ||
            permissionModule('ARTICLE_LIST', 'view')
              ? ''
              : 'hideSupport'
          "
        >
          <nav class="side-navbar main-menu">
            <ul id="side-main-menu" class="side-menu list-unstyled">
              <li>
                <router-link
                  title="Dashboard"
                  :to="'/dashboard'"
                  :class="$route.path == '/dashboard' ? 'tabActive' : ''"
                >
                  <span class="sprite1 bgIcon"
                    ><feather type="layout"></feather>
                  </span>
                  Dashboard
                </router-link>
              </li>
              <li
                :class="tab == 1 ? 'active' : ''"
                v-if="
                  permissionModule('ADMIN_LIST', 'view') ||
                  permissionModule('MANAGE_GROUP_LIST', 'view') || permissionModule('RM_ACCURACY', 'view') || get_user.id == 866
                "
              >
                <a
                  class="d-flex align-items-center justify-content-between bottom_drop"
                  href="#"
                  @click="showTabFunc('1')"
                >
                  <span class="leftMableMenu">
                    <span class="sprite4 bgIcon">
                      <feather type="file-text"></feather> </span
                    >Manage Admin
                  </span>
                  <span class="righMeniIcon">
                    <feather size="17px" type="chevron-down"></feather>
                  </span>
                </a>
                <ul class="sub-menu openBottom">
                  <li v-if="permissionModule('ADMIN_LIST', 'view')">
                    <router-link
                      title="users-list"
                      :to="'/admin-list'"
                      :class="
                        $route.path == '/admin-list' ||
                        $route.path == '/admin-view'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite2 bgIcon"
                        ><feather type="file-text"></feather
                      ></span>
                      Admin List
                    </router-link>
                  </li>

                  <li v-if="permissionModule('MANAGE_GROUP_LIST', 'view')">
                    <router-link
                      title="users-list"
                      :to="'/group-listing'"
                      :class="
                        $route.path == '/group-listing' ||
                        $route.path == '/group-view'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite2 bgIcon"
                        ><feather type="users"></feather
                      ></span>
                      Manage Group
                    </router-link>
                  </li>
                  <!--v-if="get_user.roles.indexOf('SA') != -1"-->
                  <li v-if="permissionModule('RM_ACCURACY', 'view') || get_user.id == 866">
                    <router-link
                      title="users-list"
                      :to="'/rm-accuracy'"
                      :class="$route.path == '/rm-accuracy' ? 'tabActive' : ''"
                    >
                      <span class="sprite2 bgIcon"
                        ><feather type="file-text"></feather
                      ></span>
                      RM Accuracy
                    </router-link>
                  </li>
                </ul>
              </li>
              <li :class="tab == 2 ? 'active' : ''">
                <a
                  class="d-flex align-items-center justify-content-between bottom_drop"
                  href="#"
                  @click="showTabFunc('2')"
                >
                  <span class="leftMableMenu">
                    <span class="sprite4 bgIcon">
                      <feather type="file-text"></feather> </span
                    >Manage Affiliate
                  </span>
                  <span class="righMeniIcon">
                    <feather size="17px" type="chevron-down"></feather>
                  </span>
                </a>
                <ul class="sub-menu openBottom">
                  <li>
                    <router-link
                      title="users-list"
                      :to="'/ib-list'"
                      :class="
                        $route.path == '/ib-list' || $route.path == '/ib-view'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite2 bgIcon"
                        ><feather type="file-text"></feather
                      ></span>
                      Affiliate List
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      title="commission-list"
                      :to="'commission-list'"
                      :class="
                        $route.path == '/commission-list' ||
                        $route.path == '/commission-list'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="image"></feather
                      ></span>
                      Commission Reports Download
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      title="upload-document"
                      :to="'upload-document'"
                      :class="
                        $route.path == '/upload-document' ||
                        $route.path == '/upload-document'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="image"></feather
                      ></span>
                      Commission Reports
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      title="commission-report-list"
                      :to="'commission-report-list'"
                      :class="
                        $route.path == '/commission-report-list'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="image"></feather
                      ></span>
                      Commission Report List
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      title="commission-report-list"
                      :to="'commission-withdrawal-list'"
                      :class="
                        $route.path == '/commission-withdrawal-list'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="image"></feather
                      ></span>
                      Commission Withdrawal List
                    </router-link>
                  </li>
                </ul>
              </li>
              <li :class="tab == 3 ? 'active' : ''">
                <a
                  class="d-flex align-items-center justify-content-between bottom_drop"
                  href="#"
                  @click="showTabFunc('3')"
                >
                  <span class="leftMableMenu">
                    <span class="sprite4 bgIcon">
                      <feather type="file-text"></feather> </span
                    >Manage Client
                  </span>
                  <span class="righMeniIcon">
                    <feather size="17px" type="chevron-down"></feather>
                  </span>
                </a>
                <ul class="sub-menu openBottom">
                  <li v-if="permissionModule('CLIENT_LIST', 'view')">
                    <router-link
                      title="users-list"
                      :to="'/listing'"
                      :class="
                        $route.path == '/listing' || $route.path == '/view'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite2 bgIcon"
                        ><feather type="user-check"></feather
                      ></span>
                      Client List
                    </router-link>
                  </li>
                  <li v-if="permissionModule('CLIENT_LIST', 'view')">
                    <router-link title="users-list" :to="'/reassign-leads'" :class="$route.path == '/reassign-leads'? 'tabActive' : ''">
                      <span class="sprite2 bgIcon"><feather type="user-check"></feather></span>
                      Reassign Leads
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      title="users-list"
                      :to="'/task-listing'"
                      :class="$route.path == '/task-listing' ? 'tabActive' : ''"
                    >
                      <span class="sprite2 bgIcon"
                        ><feather type="file"></feather
                      ></span>
                      Task List
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      title="users-list"
                      :to="'/notes'"
                      :class="$route.path == '/notes' ? 'tabActive' : ''"
                    >
                      <span class="sprite2 bgIcon"
                        ><feather type="archive"></feather
                      ></span>
                      Internal Notes
                    </router-link>
                  </li>
                  <!----->
                  <li
                    v-if="
                      get_user.roles.indexOf('RM') != -1 ||
                      get_user.roles.indexOf('RM-A') != -1 ||
                      get_user.roles.indexOf('RM-M') != -1
                    "
                  >
                    <router-link
                      title="request-access"
                      :to="'/request-access'"
                      :class="
                        $route.path == '/request-access' ? 'tabActive' : ''
                      "
                    >
                      <span class="sprite1 bgIcon"
                        ><feather type="layout"></feather>
                      </span>
                      Request Access
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      title="vps-list"
                      :to="'/vps-list'"
                      :class="$route.path == '/vps-list' ? 'tabActive' : ''"
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="inbox"></feather
                      ></span>
                      VPS List
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      title="subscription-list"
                      :to="'/subscription-list'"
                      :class="
                        $route.path == '/subscription-list' ? 'tabActive' : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="trello"></feather
                      ></span>
                      Subscription List
                    </router-link>
                  </li>
                  <li v-if="permissionModule('LEADS_LIST', 'view')">
                    <router-link
                      title="subscription-list"
                      :to="'/leads'"
                      :class="$route.path == '/leads' ? 'tabActive' : ''"
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="trello"></feather
                      ></span>
                      Leads
                    </router-link>
                  </li>
                  <li :class="subTab == 3 ? 'active' : ''">
                    <a
                      class="d-flex align-items-center justify-content-between bottom_drop"
                      href="#"
                      @click="subdropFunc('3')"
                    >
                      <span class="leftMableMenu">
                        <span class="sprite4 bgIcon">
                          <feather type="award"></feather> </span
                        >Loyalty
                      </span>
                      <span class="righMeniIcon">
                        <feather size="17px" type="chevron-down"></feather>
                      </span>
                    </a>
                    <ul class="sub-menu openBottom subdropdown">
                      <li>
                        <router-link
                          title="category"
                          :to="'/transaction-list'"
                          :class="
                            $route.path == '/transaction-list'
                              ? 'tabActive'
                              : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="stop-circle"></feather>
                          </span>
                          Transaction list
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          title="categoryList"
                          :to="'/card-list'"
                          :class="
                            $route.path == '/card-list' ? 'tabActive' : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="list"></feather>
                          </span>
                          Card List
                        </router-link>
                      </li>
                    </ul>
                  </li>
                  <li
                    v-if="
                      get_user.roles.indexOf('RM') != -1 ||
                      get_user.roles.indexOf('RM-A') != -1 ||
                      get_user.roles.indexOf('RM-M') != -1
                    "
                  >
                    <router-link
                      title="request-access"
                      :to="'/ib-request-access'"
                      :class="
                        $route.path == '/ib-request-access' ? 'tabActive' : ''
                      "
                    >
                      <span class="sprite1 bgIcon"
                        ><feather type="layout"></feather>
                      </span>
                      Request Access
                    </router-link>
                  </li>
                </ul>
              </li>
              <li
                :class="tab == 4 ? 'active' : ''"
                v-if="
                  permissionModule('WITHDRAWAL_LIST', 'view') ||
                  permissionModule('MANUAL_WITHDRAWAL_LIST', 'view')
                "
              >
                <a
                  class="d-flex align-items-center justify-content-between bottom_drop"
                  href="#"
                  @click="showTabFunc('4')"
                >
                  <span class="leftMableMenu">
                    <span class="sprite4 bgIcon">
                      <feather type="file-text"></feather> </span
                    >Manage Withdrawals
                  </span>
                  <span class="righMeniIcon">
                    <feather size="17px" type="chevron-down"></feather>
                  </span>
                </a>
                <ul class="sub-menu openBottom">
                  <li v-if="permissionModule('WITHDRAWAL_LIST', 'view')">
                    <router-link
                      title="withdrawal-list"
                      :to="'/withdrawal-list'"
                      :class="
                        $route.path == '/withdrawal-list' ||
                        $route.path == '/withdrawal-view'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite3 bgIcon"
                        ><feather type="credit-card"></feather></span
                      >Client's Withdrawal List
                    </router-link>
                  </li>
                  <li v-if="permissionModule('MANUAL_WITHDRAWAL_LIST', 'view')">
                    <router-link
                      title="withdrawal-account-list"
                      :to="'/withdrawal-account-list'"
                      :class="
                        $route.path == '/withdrawal-account-list'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite3 bgIcon"
                        ><feather type="book"></feather
                      ></span>
                      Manual Withdrawal List
                    </router-link>
                  </li>
                </ul>
              </li>
              <li
                :class="tab == 5 ? 'active' : ''"
                v-if="
                  permissionModule('DEPOSIT_LIST', 'view') ||
                  permissionModule('MANUAL_DEPOSIT_LIST', 'view')
                "
              >
                <a
                  class="d-flex align-items-center justify-content-between bottom_drop"
                  href="#"
                  @click="showTabFunc('5')"
                >
                  <span class="leftMableMenu">
                    <span class="sprite4 bgIcon">
                      <feather type="file-text"></feather> </span
                    >Manage Deposits
                  </span>
                  <span class="righMeniIcon">
                    <feather size="17px" type="chevron-down"></feather>
                  </span>
                </a>
                <ul class="sub-menu openBottom">
                  <li v-if="permissionModule('DEPOSIT_LIST', 'view')">
                    <router-link
                      title="deposit-list"
                      :to="'/deposit-list'"
                      :class="
                        $route.path == '/deposit-list' ||
                        $route.path == '/deposit-view'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="layers"></feather></span
                      >Client Deposit List
                    </router-link>
                  </li>
                  <li v-if="permissionModule('MANUAL_DEPOSIT_LIST', 'view')">
                    <router-link
                      title="internal-deposit-list"
                      :to="'/internal-deposit-list'"
                      :class="
                        $route.path == '/internal-deposit-list'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="tag"></feather
                      ></span>
                      Manual Deposit List
                    </router-link>
                  </li>
                </ul>
              </li>
              <li
                :class="tab == 6 ? 'active' : ''"
                v-if="
                  permissionModule('TICKET_LIST', 'view') ||
                  permissionModule('TICKET_LIST', 'view')
                "
              >
                <a
                  class="d-flex align-items-center justify-content-between bottom_drop"
                  href="#"
                  @click="showTabFunc('6')"
                >
                  <span class="leftMableMenu">
                    <span class="sprite4 bgIcon">
                      <feather type="file-text"></feather> </span
                    >Manage Tickets
                  </span>
                  <span class="righMeniIcon">
                    <feather size="17px" type="chevron-down"></feather>
                  </span>
                </a>
                <ul class="sub-menu openBottom">
                  <li v-if="permissionModule('TICKET_LIST', 'view')">
                    <router-link
                      title="ticket-list"
                      :to="'/ticket-list'"
                      :class="
                        $route.path == '/ticket-list' ||
                        ($route.path == '/ticket-view' &&
                          ticketView.hasOwnProperty('ticket') &&
                          parseInt(ticketView.ticket[0].reason) != 121)
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="tag"></feather
                      ></span>
                      Client Ticket List
                    </router-link>
                  </li>
                  <li v-if="permissionModule('TICKET_LIST', 'view')">
                    <router-link
                      title="ticket-list"
                      :to="'/ib-ticket-list'"
                      :class="
                        $route.path == '/ib-ticket-list' ||
                        ($route.path == '/ticket-view' &&
                          ticketView.hasOwnProperty('ticket') &&
                          parseInt(ticketView.ticket[0].reason) == 121)
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="twitch"></feather
                      ></span>
                      Affiliate Ticket List
                    </router-link>
                  </li>
                  <li v-if="permissionModule('INTERNAL_TICKET', 'view')">
                    <router-link
                      title="internal-ticket-list"
                      :to="'/internal-ticket-list'"
                      :class="
                        $route.path == '/internal-ticket-list'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="tag"></feather
                      ></span>
                      Internal Ticket List
                    </router-link>
                  </li>
                </ul>
              </li>
              <li>
                <router-link
                  title="bonus-list"
                  :to="'/bonus-list'"
                  :class="
                    $route.path == '/bonus-list' || $route.path == '/bonus-view'
                      ? 'tabActive'
                      : ''
                  "
                >
                  <span class="sprite4 bgIcon"
                    ><feather type="database"></feather
                  ></span>
                  Bonus List
                </router-link>
              </li>
              <li v-if="permissionModule('TRADING_LIST', 'view')">
                <router-link
                  title="trading-list"
                  :to="'/trading-list'"
                  :class="
                    $route.path == '/trading-list' ||
                    $route.path == '/trading-view'
                      ? 'tabActive'
                      : ''
                  "
                >
                  <span class="sprite5 bgIcon"
                    ><feather type="trending-up"></feather
                  ></span>
                  Trading/Wallet List
                </router-link>
              </li>
              <li v-if="
                  permissionModule('SUBSCIPTION_LIST', 'view') ||
                  permissionModule('SUBSCIPTION_UPDATE', 'view')
                ">
                <router-link
                  title="Subscription list"
                  :to="'/subscription-list'"
                  :class="
                    $route.path == '/subscription-list'
                      ? 'tabActive'
                      : ''
                  "
                >
                  <span class="sprite5 bgIcon"
                    ><feather type="trending-up"></feather
                  ></span>
                  Subscription List
                </router-link>
              </li>
              <li v-if="
                  permissionModule('LOYALITY_LIST', 'view')
                ">
                <router-link
                  title="Loyalty list"
                  :to="'/loyality-list'"
                  :class="
                    $route.path == '/loyality-list' ||
                    $route.path == '/loyality-detail'
                      ? 'tabActive'
                      : ''
                  "
                >
                  <span class="sprite5 bgIcon"
                    ><feather type="trending-up"></feather
                  ></span>
                  Loyalty Points
                </router-link>
              </li>
              <li :class="tab == 7 ? 'active' : ''">
                <a
                  class="d-flex align-items-center justify-content-between bottom_drop"
                  href="#"
                  @click="showTabFunc('7')"
                >
                  <span class="leftMableMenu">
                    <span class="sprite4 bgIcon">
                      <feather type="file-text"></feather> </span
                    >Manage Website Content
                  </span>
                  <span class="righMeniIcon">
                    <feather size="17px" type="chevron-down"></feather>
                  </span>
                </a>
                <ul class="sub-menu openBottom">
                  <li>
                    <router-link
                      title="add-webinar"
                      :to="'/webinar'"
                      :class="
                        $route.path == '/webinar' || $route.path == '/webinar'
                          ? 'tabActive'
                          : ''
                      "
                    >
                      <span class="sprite4 bgIcon"
                        ><feather type="zap"></feather
                      ></span>
                      Add Webinar
                    </router-link>
                  </li>
                  <li :class="subTab == 8 ? 'active' : ''">
                    <a
                      class="d-flex align-items-center justify-content-between bottom_drop"
                      href="#"
                      @click="subdropFunc('8')"
                    >
                      <span class="leftMableMenu">
                        <span class="sprite4 bgIcon">
                          <feather type="file-text"></feather> </span
                        >Tutorial List
                      </span>
                      <span class="righMeniIcon">
                        <feather size="17px" type="chevron-down"></feather>
                      </span>
                    </a>
                    <ul class="sub-menu openBottom subdropdown">
                      <li>
                        <router-link
                          title="category"
                          :to="'/tutorial-course'"
                          :class="
                            $route.path == '/tutorial-course' ? 'tabActive' : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="stop-circle"></feather>
                          </span>
                          Add Course
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          title="categoryList"
                          :to="'/tutorial-course-list'"
                          :class="
                            $route.path == '/tutorial-course-list'
                              ? 'tabActive'
                              : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="list"></feather>
                          </span>
                          Course List
                        </router-link>
                      </li>

                      <li>
                        <router-link
                          title="post"
                          :to="'/tutorial-category'"
                          :class="
                            $route.path == '/tutorial-category'
                              ? 'tabActive'
                              : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="file"></feather>
                          </span>
                          Add Category
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          title="postList"
                          :to="'/tutorial-category-list'"
                          :class="
                            $route.path == '/tutorial-category-list'
                              ? 'tabActive'
                              : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="edit"></feather>
                          </span>
                          Category List
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          title="postList"
                          :to="'/create-tutorial'"
                          :class="
                            $route.path == '/create-tutorial' ? 'tabActive' : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="plus"></feather>
                          </span>
                          Add Tutorial
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          title="postList"
                          :to="'/tutorials-list'"
                          :class="
                            $route.path == '/tutorials-list' ? 'tabActive' : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="file-text"></feather>
                          </span>
                          Tutorial List
                        </router-link>
                      </li>
                    </ul>
                  </li>
                  <li :class="subTab == 7 ? 'active' : ''">
                    <a
                      class="d-flex align-items-center justify-content-between bottom_drop"
                      href="#"
                      @click="subdropFunc('7')"
                    >
                      <span class="leftMableMenu">
                        <span class="sprite4 bgIcon">
                          <feather type="database"></feather>
                        </span>
                        Trading Education
                      </span>
                      <span class="righMeniIcon">
                        <feather size="17px" type="chevron-down"></feather>
                      </span>
                    </a>
                    <ul class="sub-menu openBottom subdropdown subdropdown">
                      <li>
                        <router-link
                          title="category"
                          :to="'/add-category'"
                          :class="
                            $route.path == '/add-category' ? 'tabActive' : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="stop-circle"></feather>
                          </span>
                          Add Category
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          title="categoryList"
                          :to="'/category-Listing'"
                          :class="
                            $route.path == '/category-List' ? 'tabActive' : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="list"></feather>
                          </span>
                          Get Category List
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          title="post"
                          :to="'/add-post'"
                          :class="$route.path == '/add-post' ? 'tabActive' : ''"
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="file"></feather>
                          </span>
                          Add Post
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          title="postList"
                          :to="'/post-list'"
                          :class="
                            $route.path == '/post-list' ? 'tabActive' : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="edit"></feather>
                          </span>
                          Get Post List
                        </router-link>
                      </li>
                    </ul>
                  </li>
                  <li
                    :class="subTab == 9 ? 'active' : ''"
                    v-if="
                      permissionModule('CREATE_CATEGORY', 'view') ||
                      permissionModule('CATEGORY_LIST', 'view') ||
                      permissionModule('CREATE_ARTICLE', 'view') ||
                      permissionModule('ARTICLE_LIST', 'view')
                    "
                  >
                    <a
                      class="d-flex align-items-center justify-content-between bottom_drop"
                      href="#"
                      @click="subdropFunc('9')"
                    >
                      <span class="leftMableMenu">
                        <span class="sprite4 bgIcon">
                          <feather type="file-text"></feather> </span
                        >Knowledge Base
                      </span>
                      <span class="righMeniIcon">
                        <feather size="17px" type="chevron-down"></feather>
                      </span>
                    </a>
                    <ul class="sub-menu openBottom subdropdown">
                      <li v-if="permissionModule('CREATE_CATEGORY', 'view')">
                        <router-link
                          title="category"
                          :to="'/category'"
                          :class="$route.path == '/category' ? 'tabActive' : ''"
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="stop-circle"></feather>
                          </span>
                          Knowledge Base Category
                        </router-link>
                      </li>
                      <li v-if="permissionModule('CATEGORY_LIST', 'view')">
                        <router-link
                          title="Dashboard"
                          :to="'/category-list'"
                          :class="
                            $route.path == '/category-list' ? 'tabActive' : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="list"></feather>
                          </span>
                          Category List
                        </router-link>
                      </li>
                      <li v-if="permissionModule('CREATE_ARTICLE', 'view')">
                        <router-link
                          title="articles"
                          :to="'/articles'"
                          :class="$route.path == '/articles' ? 'tabActive' : ''"
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="file"></feather>
                          </span>
                          Knowledge Base Article
                        </router-link>
                      </li>
                      <li v-if="permissionModule('ARTICLE_LIST', 'view')">
                        <router-link
                          title="Dashboard"
                          :to="'/articles-list'"
                          :class="
                            $route.path == '/articles-list' ? 'tabActive' : ''
                          "
                        >
                          <span class="sprite1 bgIcon"
                            ><feather type="edit"></feather>
                          </span>
                          Article List
                        </router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li><!--  v-if="permissionModule('ADMIN_FILE_UPLOAD', 'view')" -->
                <router-link title="Help2Pay Price Upload" :to="'/help2pay-price-upload'" :class="$route.path == '/help2pay-price-upload'?'tabActive': ''">
                  <span class="sprite5 bgIcon"><feather type="file-text"></feather></span>
                  Help2Pay Price Upload
                </router-link>
              </li>
              <li>
                <router-link title="Korapay Price Upload" :to="'/korapay-price-upload'" :class="$route.path == '/korapay-price-upload'?'tabActive': ''">
                  <span class="sprite5 bgIcon"><feather type="file-text"></feather></span>
                  Korapay Price Upload
                </router-link>
              </li>
              <!-- <li>
                <a @click.prevent="addMarketHolidays()" class="adTR d-flex align-items-center justify-content-between" href="#">Add Market Holidays</a>
              </li> -->
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
import { LayoutIcon, UserIcon, UsersIcon, LogOutIcon } from "vue-feather-icons";
export default {
  name: "fxViewApp",
  mixins: [fxViewMixins],
  data() {
    return {
      data: {},
      knowlegdeBase: false,
      tradingEducation: false,
      tutorialsList: false,
      loyality: false,
      tab: "",
      subTab: "",
    };
  },
  components: {
    LayoutIcon,
    UsersIcon,
    UserIcon,
    LogOutIcon,
  },
  computed: {
    list() {
      this.data= this.$store.state.market_holidays
      // console.log("data==>",Object.values(data))
    }
  },
  methods: {
    addMarketHolidays(){
      
      // console.log("market_holidays==",this.$store.state.market_holidays)
      const _that= this
      let input_json={
							'globalParams' : {
								'market_holidays_list' : _that.$store.state.market_holidays,
							},
							'localParams' : {'parameter' : _that}
						}
        _that._runSetMarketHolidays(input_json)
    },
    showTabFunc(getData) {
      if (this.tab == getData) {
        this.subTab = "";
        this.tab = "";
      } else {
        this.tab = parseInt(getData);
      }
    },
    subdropFunc(getData) {
      if (this.subTab == getData) {
        this.subTab = "";
      } else {
        this.subTab = parseInt(getData);
      }
    },
  },
  mounted() {
    $(".dropdown").click(function () {
      $(this).addClass("active").siblings().removeClass("active");
    });
    const _that = this;
    $(document).on("click", function (event) {
      if (!$(event.target).closest(".bottom_drop").length) {
        _that.knowlegdeBase = false;
        _that.tradingEducation = false;
        _that.tutorialsList = false;
        _that.loyality = false;
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/left_navigation.vue